import { useNavigate } from "react-router-dom";
import "./lms.css";

const Head = ({ kicker, title, intro }) => <div className="detail-h"><span className="kicker">{kicker}</span><h2>{title}</h2>{intro && <p>{intro}</p>}</div>;

/** Sidebar pages (Grades, Projects, Settings…): the prototype's page bar with a Home › Page trail, then the page. */
export default function PageFrame({ title, kicker = "Learn", intro, aside, children }) {
  const navigate = useNavigate();
  return (
    <div className="lms">
      <div className="main single">
        <div className="pagebar">
          <nav className="trail" aria-label="You are here">
            <button type="button" onClick={() => navigate("/dashboard")}>Home</button>
            <span className="sep">›</span>
            <span className="here">{title}</span>
          </nav>
        </div>
        <div className="view">
          {aside ? (
            <div className="settings-head"><Head kicker={kicker} title={title} intro={intro} />{aside}</div>
          ) : <Head kicker={kicker} title={title} intro={intro} />}
          {children}
        </div>
      </div>
    </div>
  );
}

export const Loading = () => (
  <>
    <div className="skeleton" style={{ height: 140 }} />
    <div className="skeleton" style={{ height: 220 }} />
  </>
);

export const LoadFailed = ({ what, onRetry }) => (
  <section className="complete-box">
    <div><strong>We couldn't load your {what}</strong><small>Check your connection and try again.</small></div>
    <button className="cbtn quiet" type="button" onClick={onRetry}>Try Again</button>
  </section>
);
